'use client';

import { useTranslations } from 'next-intl';

/**
 * Renders during the dynamic import of the Journey 3D bundle.
 * Pure DOM + CSS animation — no JS deps so it loads instantly.
 * Fades out via CSS opacity transition when the parent unmounts it
 * (handled by next/dynamic when the chunk resolves).
 */
export function JourneyLoadingMark() {
  const t = useTranslations('Journey');
  return (
    <div className="journey-loading absolute inset-0 z-20 flex flex-col items-center justify-center bg-(--color-primary-dark)">
      <div className="journey-loading__rooms" aria-hidden>
        <span />
        <span />
        <span />
        <span />
      </div>
      <div className="mt-8 flex flex-col items-center gap-1">
        <span className="font-mono text-[0.6rem] uppercase tracking-[8px] text-(--color-accent)">
          Wantek
        </span>
        <span className="font-mono text-[0.55rem] uppercase tracking-[6px] text-(--color-muted-foreground)">
          {t('loading')}
        </span>
      </div>
    </div>
  );
}
